export default {
  FIRST_NAME: {
    label: 'Имя',
    info: '',
    mask: '',
    type: ''
  },
  LAST_NAME: {
    label: 'Фамилия',
    info: '',
    mask: '',
    type: ''
  },
  SECOND_NAME: {
    label: 'Отчество',
    info: 'Если нет отчества, то поставте знак -',
    mask: '',
    type: ''
  },
  GENDER: {
    label: 'Пол',
    info: '',
    mask: '',
    type: '',
    selectOption: [
      {valueOption: 'M', nameOption: 'Мужчина'},
      {valueOption: 'F', nameOption: 'Женщина'}]
  },
  EXPER_RADIO: {
    label: 'Стаж на последнем месте работы',
    info: '',
    mask: '',
    type: '',
    selectOption: [
      {valueOption: 'Не работаю', nameOption: 'Не работаю'},
      {valueOption: 'До 3 мес.', nameOption: 'До 3 мес.'},
      {valueOption: 'От 3 мес. до года', nameOption: 'От 3 мес. до года'},
      {valueOption: 'От года до 3-х лет', nameOption: 'От года до 3-х лет'},
      {valueOption: 'От 3-х до 5-ти лет', nameOption: 'От 3-х до 5-ти лет'},
      {valueOption: 'От 5-ти до 10-ти лет', nameOption: 'От 5-ти до 10-ти лет'},
      {valueOption: 'Свыше 10-ти лет', nameOption: 'Свыше 10-ти лет'}
    ]
  },
  CREDHISTORY_RADIO: {
    label: 'Кредитная история',
    info: '',
    mask: '',
    type: '',
    selectOption: [
      {valueOption: 'Нет, кредиты не брал', nameOption: 'Нет, кредиты не брал'},
      {valueOption: 'Да, есть погашенные кредиты', nameOption: 'Да, есть погашенные кредиты'},
      {valueOption: 'Да, есть непогашенные кредиты', nameOption: 'Да, есть непогашенные кредиты'}
    ]
  },
  CALC_SUMM: {
    label: 'Сумма займа',
    info: '',
    mask: '',
    type: '',
    selectOption: [{valueOption: 20000, nameOption: 20000},
      {valueOption: 21000, nameOption: 21000},
      {valueOption: 22000, nameOption: 22000},
      {valueOption: 23000, nameOption: 23000},
      {valueOption: 24000, nameOption: 24000},
      {valueOption: 25000, nameOption: 25000},
      {valueOption: 26000, nameOption: 26000},
      {valueOption: 27000, nameOption: 27000},
      {valueOption: 28000, nameOption: 28000},
      {valueOption: 29000, nameOption: 29000},
      {valueOption: 30000, nameOption: 30000},
      {valueOption: 31000, nameOption: 31000},
      {valueOption: 32000, nameOption: 32000},
      {valueOption: 33000, nameOption: 33000},
      {valueOption: 34000, nameOption: 34000},
      {valueOption: 35000, nameOption: 35000},
      {valueOption: 36000, nameOption: 36000},
      {valueOption: 37000, nameOption: 37000},
      {valueOption: 38000, nameOption: 38000},
      {valueOption: 39000, nameOption: 39000},
      {valueOption: 40000, nameOption: 40000},
      {valueOption: 41000, nameOption: 41000},
      {valueOption: 42000, nameOption: 42000},
      {valueOption: 43000, nameOption: 43000},
      {valueOption: 44000, nameOption: 44000},
      {valueOption: 45000, nameOption: 45000},
      {valueOption: 46000, nameOption: 46000},
      {valueOption: 47000, nameOption: 47000},
      {valueOption: 48000, nameOption: 48000},
      {valueOption: 49000, nameOption: 49000},
      {valueOption: 50000, nameOption: 50000}
    ]
  },
  BIRTHDAY: {
    label: 'Дата рождения',
    info: '',
    mask: '',
    type: 'date'
  },
  BIRTHPLACE: {
    label: 'Место рождения',
    info: '',
    mask: '',
    type: ''
  },
  CALC_WEEK: {
    label: 'Срок займа',
    info: '',
    mask: '',
    type: ''
  },
  CONST_INCOME: {
    label: 'Сумма дохода',
    info: '',
    mask: '##############',
    type: ''
  },
  EMAIL: {
    label: 'Email',
    info: 'Если неиспользует поставте символ -',
    mask: '',
    type: ''
  },
  IS_ADDRESS_COINCIDES: {
    label: 'Адрес регистраци совпадает с адресом проживания',
    info: '',
    mask: '',
    type: ''
  },
  IS_I_CERTIFY_REGISTRATION: {
    label: 'Согласен с передачей данных',
    info: '',
    mask: '',
    type: ''
  },
  MEETING_DATE: {
    label: 'Желаемая дата встречи с менеджером',
    info: '',
    mask: '',
    type: 'date'
  },
  MEETING_HOUR: {
    label: 'Желаемое время встречи с менеджером',
    info: '',
    mask: '',
    type: 'time'
  },
  OTHER_SOURCES_OF_INCOME: {
    label: 'Иной источник дохода',
    info: 'Если нету поставить 0',
    mask: '##############',
    type: ''
  },
  PASSPORT_DATE: {
    label: 'Дата выдачи паспорта',
    info: '',
    mask: '',
    type: 'date'
  },
  PASSPORT_DEP: {
    label: 'Кем выдан',
    info: '',
    mask: '',
    type: ''
  },
  PASSPORT_DEP_CODE: {
    label: 'Код подразделения',
    info: '',
    mask: '###-###',
    type: ''
  },
  PASSPORT_NUMBER: {
    label: 'Номер паспорта',
    info: '',
    mask: '######',
    type: ''
  },
  PASSPORT_SERIES: {
    label: 'Серия паспорта',
    info: '',
    mask: '####',
    type: ''
  },
  PHONE: {
    label: 'Телефон для связи',
    info: '',
    mask: '+7 (###) ###-##-##',
    type: ''
  },
  PHONE_FOR_CALL: {
    label: 'Телефон для связи',
    info: '',
    mask: '+7 (###) ###-##-##',
    type: ''
  },
  PHONE_ADDITIONAL: {
    label: 'Телефон для связи',
    info: '',
    mask: '+7 (###) ###-##-##',
    type: ''
  },
  PRODUCT_ID: {
    label: 'Тип продукта',
    info: '',
    mask: '',
    type: ''
  },
  REGISTRATION_ADDRESS: {
    label: 'Адрес регистрации',
    info: '',
    mask: '',
    type: ''
  },
  REGISTRATION_ADDRESS_DADATA: {
    label: '',
    info: '',
    mask: '',
    type: ''
  },
  RESIDENTIAL_ADDRESS: {
    label: 'Адрес фактического проживания',
    info: '',
    mask: '',
    type: ''
  },
  RESIDENTIAL_ADDRESS_DADATA: {
    label: '',
    info: '',
    mask: '',
    type: ''
  },
  WORK_JOB: {
    label: 'Наименование компании',
    info: 'Пример: "ОАО Молоко","ИП Петрович","на пенсии","студент" и прочее',
    mask: '',
    type: ''
  },
  null: {
    label: '',
    info: '',
    mask: '',
    type: ''
  },
  finderFio:{
    label: 'Поиск по ФИО клиента',
    info: '',
    mask: '',
    type: ''
  },
  finderPhone:{
    label: 'Поиск по номеру телефона',
    info: '',
    mask: '+7 (###) ###-##-##',
    type: ''
  },
  WHERE_TO_FIND_US:{
    label: 'Откуда о нас узнали',
    info: '',
    mask: '',
    type: '',
    selectOption:[]
  },
  ReCallDate:{
    label: 'Дата звонка',
    info: '',
    mask: '',
    type: 'date',
    selectOption:[]
  },
  ReCallTime:{
    label: 'Время звонка',
    info: '',
    mask: '##:##',
    type: 'time',
    selectOption:[]
  },
  CAR_NUMBER:{
    label: 'Гос. номер автомобиля',
    info: 'пример: х010хх777',
    mask: '',
    type: '',
  },
  WORK_TITLE:{
    label: 'Должность',
    info: '',
    mask: '',
    type: '',
  }
}
